export default "__VITE_ASSET__1HeOZ2CR__"